import { useState, useEffect } from "react";

function LoadingDotsPage() {
    let [dots, setDots] = useState(".");

    useEffect(() => {
        const interval = setInterval(() => {
        setDots(prev => (prev.length < 3 ? prev + '.' : '.'));
        }, 500);

        return () => clearInterval(interval);
    }, []);

    return (
        <h1>
            Chargement en cours{dots}
        </h1>
    )
}

export default LoadingDotsPage;